"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _wrapDisplayName = _interopRequireDefault(require("recompose/wrapDisplayName"));

var _recompose = require("recompose");

var _prefix = _interopRequireDefault(require("./prefix"));

var _constants = require("./constants");

var withStyleProps = function withStyleProps(options) {
  if (options === void 0) {
    options = {};
  }

  return function (Component) {
    var _options = options,
        hasSize = _options.hasSize,
        hasStatus = _options.hasStatus,
        hasColor = _options.hasColor,
        defaultColor = _options.defaultColor;

    var WithStyleProps =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inheritsLoose2.default)(WithStyleProps, _React$Component);

      function WithStyleProps() {
        return _React$Component.apply(this, arguments) || this;
      }

      var _proto = WithStyleProps.prototype;

      _proto.render = function render() {
        var _classNames;

        var _this$props = this.props,
            classPrefix = _this$props.classPrefix,
            size = _this$props.size,
            color = _this$props.color,
            status = _this$props.status,
            innerRef = _this$props.innerRef,
            className = _this$props.className,
            props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["classPrefix", "size", "color", "status", "innerRef", "className"]);
        var addPrefix = (0, _prefix.default)(classPrefix);
        var classes = (0, _classnames.default)(className, (_classNames = {}, _classNames[addPrefix(size)] = hasSize && size, _classNames[addPrefix(color)] = hasColor && color, _classNames[addPrefix(defaultColor)] = !color, _classNames[addPrefix(status)] = hasStatus && status, _classNames));
        return React.createElement(Component, (0, _extends2.default)({}, props, {
          classPrefix: classPrefix,
          className: classes,
          ref: innerRef
        }));
      };

      return WithStyleProps;
    }(React.Component);

    (0, _defineProperty2.default)(WithStyleProps, "displayName", (0, _wrapDisplayName.default)(Component, 'withStyleProps'));
    (0, _defineProperty2.default)(WithStyleProps, "defaultProps", Component.defaultProps);
    (0, _defineProperty2.default)(WithStyleProps, "handledProps", []);
    var propTypes = {
      innerRef: _propTypes.default.func
    };

    if (hasSize) {
      propTypes.size = _propTypes.default.oneOf(_constants.SIZE);
    }

    if (hasColor) {
      propTypes.color = _propTypes.default.oneOf(_constants.COLOR);
    }

    if (hasStatus) {
      propTypes.status = _propTypes.default.oneOf(_constants.STATUS);
    }

    (0, _recompose.setPropTypes)(propTypes)(WithStyleProps);
    return WithStyleProps;
  };
};

withStyleProps.handledProps = [];
var _default = withStyleProps;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/lib/utils/withStyleProps.js
// module id = 1748
// module chunks = 0